import GitHubIcon from '@material-ui/icons/GitHub'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import { SiGooglescholar } from 'react-icons/si'
import { about } from '../../portfolio'
import './About.css'

const base = process.env.PUBLIC_URL || ''

const About = () => {
  const { name, role, description, resume, social } = about

  return (
    <div className='about'>
      <div className='about__intro'>
        {name && (
          <h1>
            Hi, I'm <span className='about__name'>{name}.</span>
          </h1>
        )}

        {role && <h2 className='about__role'>A {role}.</h2>}
        <p className='about__desc'>{description && description}</p>

        <div className='about__contact'>
          {resume && (
            <a href={resume} target='_blank' rel='noopener noreferrer'>
              <span type='button' className='btn btn--outline'>
                Resume
              </span>
            </a>
          )}

          {social && (
            <>
              {social.github && (
                <a
                  href={social.github}
                  aria-label='github'
                  className='link link--icon'
                >
                  <GitHubIcon />
                </a>
              )}

              {social.linkedin && (
                <a
                  href={social.linkedin}
                  aria-label='linkedin'
                  className='link link--icon'
                >
                  <LinkedInIcon />
                </a>
              )}
              {social.googleScholar && (
                <a
                  href={social.googleScholar}
                  aria-label='google scholar'
                  className='link link--icon'
                >
                  <SiGooglescholar />
                </a>
              )}
            </>
          )}
        </div>
      </div>

      <div className='about__visual'>
        <div className='about__portrait'>
          <img src={`${base}/images/portrait2.jpg`} alt={name} />
        </div>
      </div>
    </div>
  )
}

export default About
